import {createContext, useContext} from 'react';
import type {GroupConfig} from '@client/pages/public/enroll/types';

const EnrollGroupContext = createContext<GroupConfig | null>(null);

export const EnrollGroupProvider = EnrollGroupContext.Provider;

export function useEnrollGroup(): GroupConfig {
  const group = useContext(EnrollGroupContext);
  if (!group) {
    throw new Error('useEnrollGroup must be used within an EnrollLayout');
  }
  return group;
}
